import React, { Fragment, useContext, useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Breadcrumbs,
  Link,
  Paper,
  TextField,
  Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// Contexts
import LayoutContext from "../../../context/layout/LayoutContext";
import FacebookProfilesDashboardContext from "../../../context/facebook_profiles/dashboard/DashboardContext";

// Components

const useStyles = makeStyles((theme) => ({
  paper: {
    marginBottom: "1rem",
    padding: "0.5rem",
    width: "100%",
  },
  button: {
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
    "&:hover": {
      color: "white",
    },
  },
}));

const EditProfile = () => {
  const classes = useStyles();

  const { setAlert } = useContext(LayoutContext);
  const {
    selected_profile,
    profile_form,
    setProfile,
    editProfile,
    profiles_error,
    clearProfilesError,
  } = useContext(FacebookProfilesDashboardContext);

  const [profile_path, setProfilePath] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const paths = window.location.pathname.split("/");

  const handleChange = (e) => {
    let value = e.target.value;

    if (e.target.id === "profile_id") {
      value = value.toUpperCase().replace(/\s+/g, "");
    }

    setProfile({ ...profile_form, [e.target.id]: value.trim() });
  };

  const onSubmit = (e) => {
    e.preventDefault();

    setSubmitted(true);
    editProfile(selected_profile.profile_id, profile_form);
  };

  const onCancel = (e) => {
    e.preventDefault();

    window.location.replace(
      window.location.origin +
        `/${paths[1]}/${paths[2]}/${selected_profile.profile_id}`
    );
  };

  useEffect(() => {
    setProfilePath(`/${paths[1]}/${paths[2]}/${paths[3]}`);

    setProfile({
      action: "Edit",
      profile_id: selected_profile.profile_id,
      access_token: selected_profile.access_token,
    });
  }, []);

  useEffect(() => {
    if (selected_profile && submitted) {
      setAlert("Profile Updated.", "success");

      window.location.replace(
        window.location.origin +
          `/${paths[1]}/${paths[2]}/${selected_profile.profile_id}`
      );
    }
  }, [selected_profile]);

  useEffect(() => {
    if (profiles_error) {
      if (profiles_error.msg === "Server Error") {
        setAlert(profiles_error.error, "error");
      } else {
        setAlert(profiles_error.msg, "error");
      }

      setSubmitted(false);
      clearProfilesError();
    }
  }, [profiles_error]);

  return (
    <Fragment>
      <Grid container spacing={0} justifyContent="flex-start">
        <Grid item xs={12}>
          <Typography variant="h4"> Facebook Profile </Typography>
        </Grid>
        <Grid item xs={12}>
          <Breadcrumbs aria-label="breadcrumb">
            
            {/* <Link color="inherit" href="/facebook/profile">
                          Profile
                        </Link> */}
            <Link color="inherit" href={profile_path}>
              
              {selected_profile.profile_id}
            </Link>
            <Link color="inherit"> Edit </Link>
          </Breadcrumbs>
        </Grid>
      </Grid>
      <Grid item xs={12} container>
        <Paper className={classes.paper}>
          <form onSubmit={onSubmit}>
            <Grid
              container
              spacing={2}
              justifyContent="space-between"
              alignItems="flex-start"
            >
              <Grid item xs={2}>
                <TextField
                  fullWidth
                  required
                  variant="outlined"
                  type="text"
                  size="small"
                  margin="dense"
                  label="Profile ID"
                  id="profile_id"
                  name="profile_id"
                  value={profile_form.profile_id}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={10}>
                <TextField
                  fullWidth
                  required
                  variant="outlined"
                  type="text"
                  size="small"
                  margin="dense"
                  label="Access Token"
                  id="access_token"
                  name="access_token"
                  value={profile_form.access_token}
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
            <Grid
              container
              spacing={1}
              justifyContent="flex-end"
              alignItems="flex-end"
            >
              <Grid item>
                <Button
                  className={classes.button}
                  variant="contained"
                  color="primary"
                  type="submit"
                  id="edit_profile"
                  disabled={submitted}
                >
                  Save
                </Button>
              </Grid>
              <Grid item>
                <Button
                  className={classes.button}
                  variant="contained"
                  color="secondary"
                  type="button"
                  id="edit_profile"
                  onClick={onCancel}
                  disabled={submitted}
                >
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Grid>
    </Fragment>
  );
};

export default EditProfile;
